import { Controller } from "@hotwired/stimulus"

// Removes duplicate posts that arrive via both turbo_stream response and broadcast
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE || !node.id) continue
          const duplicates = this.element.querySelectorAll(`#${CSS.escape(node.id)}`)
          if (duplicates.length > 1) {
            // Keep the first one (most recent prepend), remove the rest
            for (let i = 1; i < duplicates.length; i++) {
              duplicates[i].remove()
            }
          }
        }
      }
    })
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
